export default __webpack_public_path__ + "4c5713aa7d0b5e38bf168ac9e6a7584c.png";